import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { StatusRo } from './status-ro';


@Component({
  selector: 'yt-status-ro-modal-update',
  templateUrl: './status-ro-modal-update.component.html'
})
export class StatusRoModalUpdateComponent 
extends BaseModalUpdateComponent<StatusRo> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<StatusRo>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
    
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
